export const CandidateCheckScreens = {
  REFERENCE: 'reference',
  CUSTOM_REFERENCE: 'custom_reference',
  QUESTIONNAIRE: 'questionnaire',
  DOCUMENT_SIGNING: 'document_signing',
  SUCCESS: 'success',
  COMPLETED: 'completed',
  US_MEDICAL_SCREEN: 'us_medical_screen',
};
